import { createSelector } from 'reselect';
const getContextFramesMemberState = createSelector((state) => state.contextFrames, contextFrames => contextFrames.member || {
    contextFrames: [],
    language: '',
    eTag: '',
    loading: false,
    error: null,
});
export default getContextFramesMemberState;
